import React from 'react';
import {FavoriteProductContent} from './sub-view/favorite-product-content';
import {UserLayout} from 'components/layouts/user';

class SendComplaintContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <UserLayout active="user-favorites">
        <h1 className="user-header">Sản phẩm / Dịch vụ yêu thích</h1>
        <FavoriteProductContent/>
      </UserLayout>
    );
  }
}

export default SendComplaintContainer;



// WEBPACK FOOTER //
// ./components/users/FavoriteProductContainer.jsx